import React, { useContext, useMemo, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import * as mdHelpers from "../MasterDataHelper";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  toastOption
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useMasterDataAddUserContext } from "../MasterDataUserUIContext";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  fetchUsersBySuperAdmin,
  deleteUserSuperAdmin
} from "../../../_redux/master-data-user/masterDataUserAction";
import ConfirmationDeleteModal from "../../../../Project/pages/modal-for-project/ConfirmationDeleteModal";
import { toast } from "react-toastify";

const MasterDataUserTable = ({ allowEdit }) => {
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [currentItem, setCurrentItem] = useState({});

  const dispatch = useDispatch();

  const masterDataUserContext = useMasterDataAddUserContext();
  const masterDataUIProps = useMemo(() => {
    return {
      queryParams: masterDataUserContext.queryParams,
      setQueryParams: masterDataUserContext.setQueryParams,
      addNewUser: masterDataUserContext.addNewUser,
      editUser: masterDataUserContext.editUser
    };
  }, [masterDataUserContext]);

  const { totalCount, entities, listLoading, actionsLoading } = useSelector(
    state => state.superAdminMasterDataUser,
    shallowEqual
  );

  useEffect(() => {
    console.log(`masterDataUIProps.queryParams`, masterDataUIProps.queryParams);
    dispatch(fetchUsersBySuperAdmin(masterDataUIProps.queryParams));
  }, [masterDataUIProps.queryParams, dispatch]);

  const columns = [
    {
      dataField: "name",
      text: "Nama",
      sort: true
    },
    {
      dataField: "email",
      text: "Email",
      sort: true
    },
    {
      dataField: "role",
      text: "Role",
      sort: true
    },
    {
      dataField: "hp",
      text: "No. HP",
      sort: false
    },
    {
      dataField: "regional.name",
      text: "Region",
      sort: false
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditUserPage: masterDataUIProps.editUser,
        setConfirmationModal,
        setCurrentItem,
        allowEdit
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px"
      }
    }
  ];

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: mdHelpers.sizePerPageList,
    sizePerPage: masterDataUIProps.queryParams.pageSize,
    page: masterDataUIProps.queryParams.pageNumber
  };

  const deleteUser = () => {
    dispatch(
      deleteUserSuperAdmin(currentItem.uuid, {
        ...currentItem,
        is_active: false
      })
    )
      .then(res => {
        toast.success(res.message, toastOption);
        dispatch(fetchUsersBySuperAdmin(masterDataUIProps.queryParams));

        setConfirmationModal(false);
        setCurrentItem({});
      })
      .catch(err => {
        toast.error("Data Gagal Dihapus", toastOption);
        setCurrentItem({});
        setConfirmationModal(false);
      });
  };

  return (
    <>
      <ConfirmationDeleteModal
        onHide={() => {
          setConfirmationModal(false);
          setCurrentItem({});
        }}
        show={confirmationModal}
        onClick={() => deleteUser()}
        title={`Hapus user ${currentItem.name}`}
        content="Apakah kamu yakin ingin menghapus user ini?"
      />
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                onTableChange={getHandlerTableChange(
                  masterDataUIProps.setQueryParams
                )}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default MasterDataUserTable;
